// 쇼핑몰 연동(CAFE24·IMWEB) 필드는 stibee2.0 EditorSender(step03)와 동일 규칙으로 노출한다:
// 숨김(isVisible=false) 필드와 회원 여부 센티넬은 메일머지 목록에서 제외.
const SHOP_INTEGRATION_SOURCES = ['CAFE24', 'IMWEB'];

export const isAllowedFieldForMailMerge = (item) => {
  const isShopField = SHOP_INTEGRATION_SOURCES.includes(item.source);
  const isVisible = !isShopField || item.isVisible;
  const isSystemField = item.substitution.startsWith('$') && !isShopField;
  const isExcludedField = ['$cafe24_subscribed', '$imweb_subscribed'].includes(item.substitution);
  return !isExcludedField && isVisible && !isSystemField;
}
